<template></template>

<script>
export default {
  name: 'AuthRedirect',
  async beforeMount() {
    if (typeof Storage !== 'undefined') {
      // reset UI session
      localStorage.setItem('lastActivityTime', JSON.stringify(Date.now()));
    }

    // Handle the OKTA authentication
    // This will setup the TOKEN into the session and cookies
    try {
      await this.$auth.handleAuthentication();

      // Retrieve the user
      const user = await this.$auth.getUser();

      // User does not exists - we need to redirect to login page
      // Could be a direct access to implicit callback page...
      // Unlikely to happen - though it did once...
      if (user == null || typeof user == 'undefined') {
        // reset the sessionStorage to ensure that future implicit flow redirect to default
        if (typeof Storage !== 'undefined') {
          sessionStorage.removeItem('implicitCallbackRedirect');
        }

        // restart to login
        this.$router.replace({
          path: '/login',
        });

        return;
      }

      // User exist - then proceed
      if (user.hasAgreedChallengerTerms) {
        // The user accepted the terms and condition before so we can redirect him
        // Default path will be the homepage unless something is setup on the session storage to redirect to a specific route
        let redirectTo = '/';
        if (typeof Storage !== 'undefined') {
          let implicitRedirect = null;
          // check if exist - to avoid exception
          if (sessionStorage.getItem('implicitCallbackRedirect') !== null) {
            implicitRedirect = JSON.parse(sessionStorage.getItem('implicitCallbackRedirect'));
          }

          if (implicitRedirect != null && typeof implicitRedirect != 'undefined') {
            redirectTo = implicitRedirect;
          }
        }

        this.$router.replace({
          path: redirectTo,
        });
      } else {
        this.$router.replace({
          path: '/terms',
        });
      }
    } catch (exception) {
      // Error trying to handle authentication:
      // One case scenario is when you login as admin to access the logger. then try to login to IOL.
      // The error returned will be that you dont have access to the APP - or your user is unauthorized
      if(this.$logger && typeof(this.$logger)!=='undefined'){
        this.$logger.error('AuthRedirect error - ', exception);
      }
      // any error we want to logout..
      this.$router.push({
        path: '/logout',
      });
    }

    // reset the sessionStorage to ensure that future implicit flow redirect to default
    if (typeof Storage !== 'undefined') {
      sessionStorage.removeItem('implicitCallbackRedirect');
    }
  },
};
</script>
